import React from "react";
import SettingDialog from "./SettingDialog";
import "./Nobody.css";

export default class Nobody extends React.Component{
    render(){
        return (
            <div className="Nobody" style={{
                backgroundImage:`url(https://source.unsplash.com/collection/948102/${window.innerWidth}x${window.innerHeight})`,
                width:'100vw',
                height:'100vh',
                backgroundSize:'cover'
            }}>
                <div className="notice">
                    <div className="icon"></div>
                    <div className="slogan">
                        아무도 닿지 않은 곳 입니다<br/>
                        여기에 교실을 짓겠습니까?
                    </div>
                    <div style={{textAlign:'center', 'paddingTop':'1.3rem'}}>
                        <SettingDialog campaignId={this.props.campaignId}/>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/container/campaign/component/Nobody.js